import styled, { keyframes } from 'styled-components'

import { CircularProgressColor } from './CircularProgress.types'

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const s = {
  backdrop: styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1005;
  `,
  box: styled.div<{ $centered?: boolean; $sizePX: number }>`
    position: ${(p) => (p.$centered ? 'absolute' : 'relative')};
    left: ${(p) => (p.$centered ? '50%' : undefined)};
    top: ${(p) => (p.$centered ? '50%' : undefined)};
    margin-left: ${(p) => (p.$centered ? `-${p.$sizePX / 2}px` : undefined)};
    margin-top: ${(p) => (p.$centered ? `-${p.$sizePX / 2}px` : undefined)};
    width: ${(p) => p.$sizePX}px;
    height: ${(p) => p.$sizePX}px;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  body: styled.div<{ $sizePX: number; $duration: number; $brand?: boolean }>`
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    animation: ${rotate} ${(p) => p.$duration}s infinite linear;

    svg {
      width: ${(p) => p.$sizePX}px;
      height: ${(p) => p.$sizePX}px;

      path {
        stroke: ${(p) => (p.$brand ? 'var(--theme-colors-theme-brand-darker)' : undefined)};
      }
    }
  `,
  label: styled.span<{ $color: CircularProgressColor }>`
    color: ${(p) =>
      p.$color === 'inverted'
        ? 'var(--theme-colors-global-general-main)'
        : 'var(--theme-colors-global-general-secondary)'};
    font: var(--theme-typography-bodyS-regular);
  `
}
